import * as React from "react";
import "../assets/css/global.css";
import { StaticImage } from "gatsby-plugin-image";
import "../assets/css/footer.css";
import { Link } from "gatsby";

const FooterSection = () => (
  <>
    <div className="footer-wrapper">
      <div className="container-wrapper">
        <div className="footer-content">
          <div className="row">
            <div className="col-lg-3 col-md-6 col-xs-12 col-12 footer-center">
              <div className="helpline">
                <h3>Our Helpline Number</h3>
                <h2>+91 9980448044</h2>
              </div>
            </div>
            <div className="col-lg-5 col-md-6 col-xs-12 col-12 footer-center">
              <div className="footer-about">
                <h3>Available : Mon - Fri 9:00 AM to 6:00 PM IST</h3>
                <p>
                  Preferred Date & Time for Sample Collection, can vary based on
                  availability of qualified phlebotomist and location
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-xs-12 col-12 footer-center">
              <div className="follow-section">
                <div className="follow-tag">
                  <h3>Follow us</h3>
                  <p>we'd love to hear from you</p>
                </div>
                <div className="social-links">
                  <Link
                    to="https://www.facebook.com/StrandLife"
                    target="_blank"
                    className="facebook"
                    id="facebook"
                  >
                    <StaticImage
                      src="../assets/images/facebook.png"
                      alt="facebook"
                    />
                  </Link>
                  <Link
                    to="https://www.instagram.com/strandlifesciences/"
                    target="_blank"
                    className="instagram"
                    id="instagram"
                  >
                    <StaticImage
                      src="../assets/images/instagram.png"
                      alt="instagram"
                    />
                  </Link>
                  <Link
                    to="https://www.youtube.com/user/StrandLifeSciences"
                    target="_blank"
                    className="youtube"
                    id="youtube"
                  >
                    <StaticImage
                      src="../assets/images/youtube.png"
                      alt="youtube"
                    />
                  </Link>
                  <Link
                    to="https://www.linkedin.com/company/strand-life-sciences"
                    target="_blank"
                    className="linkedin"
                    id="linkedin"
                  >
                    <StaticImage
                      src="../assets/images/linkdein.png"
                      alt="linkedin"
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);

export default FooterSection;
